"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Dialog_base_1 = require("./Dialog.base");
var Dialog_styles_1 = require("./Dialog.styles");
exports.Dialog = Utilities_1.styled(Dialog_base_1.DialogBase, Dialog_styles_1.getStyles, undefined, { scope: 'Dialog' });
//# sourceMappingURL=Dialog.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Dialog/Dialog.js
// module id = 916
// module chunks = 0